export type ProductId = 'confluence' | 'jira' | 'loom' | 'rovo';
export type NewProductId = ProductId;
export type ThirdPartyAppId = 'claude' | 'figma' | 'gitlab' | 'miro';
export type AvatarId = 'you';
export type WorkGlyph = 'decision' | 'epic' | 'page' | 'project' | 'team' | 'video';

type BaseNode = {
	id: string;
	stage: number;
	x: number;
	y: number;
};

export type ProductNode = BaseNode & {
	isNew?: boolean;
	kind: 'product';
	product: ProductId;
};

export type WorkNode = BaseNode & {
	glyph: WorkGlyph;
	kind: 'work';
};

export type PersonNode = BaseNode & {
	avatarId: AvatarId;
	color: string;
	initials: string;
	kind: 'person';
	radius: number;
};

export type AppNode = BaseNode & {
	app: ThirdPartyAppId;
	kind: 'app';
};

export type GraphNode = ProductNode | WorkNode | PersonNode | AppNode;

export type GraphEdge = {
	bend?: number;
	from: string;
	stage: number;
	to: string;
};

export const nodes: GraphNode[] = [
	{
		id: 'you',
		kind: 'person',
		avatarId: 'you',
		x: 704,
		y: 214,
		stage: 0,
		initials: 'YO',
		color: '#1868db',
		radius: 45,
	},
	{ id: 'confluence', kind: 'product', product: 'confluence', x: 902, y: 174, stage: 1 },
	{ id: 'jira', kind: 'product', product: 'jira', x: 563, y: 137, stage: 1 },
	{ id: 'loom', kind: 'product', product: 'loom', x: 526, y: 326, stage: 1 },
	{ id: 'rovo', kind: 'product', product: 'rovo', x: 855, y: 350, stage: 1 },
	{ id: 'project1', kind: 'work', x: 222, y: 64, stage: 4, glyph: 'project' },
	{ id: 'epic', kind: 'work', x: 382, y: 147, stage: 4, glyph: 'epic' },
	{ id: 'decision', kind: 'work', x: 433, y: 234, stage: 4, glyph: 'decision' },
	{ id: 'meeting', kind: 'work', x: 233, y: 334, stage: 4, glyph: 'video' },
	{ id: 'page1', kind: 'work', x: 862, y: 63, stage: 4, glyph: 'page' },
	{ id: 'team', kind: 'work', x: 1055, y: 69, stage: 4, glyph: 'team' },
	{ id: 'page2', kind: 'work', x: 1058, y: 242, stage: 4, glyph: 'page' },
	{ id: 'gitlab', kind: 'app', app: 'gitlab', x: 494, y: 40, stage: 4 },
	{ id: 'claude', kind: 'app', app: 'claude', x: 453, y: 79, stage: 4 },
	{ id: 'miro', kind: 'app', app: 'miro', x: 1147, y: 206, stage: 4 },
	{ id: 'figma', kind: 'app', app: 'figma', x: 1173, y: 271, stage: 4 },
];

export const edges: GraphEdge[] = [
	{ from: 'you', to: 'confluence', stage: 1, bend: -10 },
	{ from: 'you', to: 'jira', stage: 1, bend: 10 },
	{ from: 'you', to: 'loom', stage: 1, bend: 8 },
	{ from: 'you', to: 'rovo', stage: 1, bend: -8 },
	{ from: 'jira', to: 'epic', stage: 4, bend: 6 },
	{ from: 'epic', to: 'decision', stage: 4, bend: 4 },
	{ from: 'jira', to: 'decision', stage: 4, bend: -6 },
	{ from: 'epic', to: 'project1', stage: 4, bend: 6 },
	{ from: 'project1', to: 'meeting', stage: 4 },
	{ from: 'loom', to: 'meeting', stage: 4 },
	{ from: 'jira', to: 'gitlab', stage: 4, bend: 4 },
	{ from: 'jira', to: 'claude', stage: 4, bend: -4 },
	{ from: 'jira', to: 'page1', stage: 4, bend: -46 },
	{ from: 'confluence', to: 'page1', stage: 4, bend: 6 },
	{ from: 'page1', to: 'team', stage: 4, bend: -12 },
	{ from: 'team', to: 'miro', stage: 4, bend: 6 },
	{ from: 'confluence', to: 'page2', stage: 4, bend: -10 },
	{ from: 'page2', to: 'figma', stage: 4, bend: 6 },
];
